import React from 'react';
import LoanCalculatorComponent from './LoanCalculator';
import { LoanCalculatorProvider } from './state/LoanCalculatorContext';

const LoanCalculatorWithProvider: React.FC<any> = (props) => (
  <LoanCalculatorProvider>
    <LoanCalculatorComponent {...props} />
  </LoanCalculatorProvider>
);

export default LoanCalculatorWithProvider;
